import "./SideBar.scss";
import { useContext } from "react";
import { menuContext } from "../../context/menucontext";
import { NavLink } from "react-router-dom";

const SideBar = () => {
  const { menuStatus, setMenuStatus } = useContext(menuContext);

  return (
    <section className={`sidebar_sec ${menuStatus ? "open" : "close"}`}>
      <div className={`side_card ${menuStatus ? "open" : "close"}`}>
        <div className="links_wrap">
          <NavLink to="/" onClick={() => setMenuStatus(false)}>
            Home
          </NavLink>
          <NavLink to="/about" onClick={() => setMenuStatus(false)}>
            About
          </NavLink>
          {/* <NavLink to="/solutions" onClick={() => setMenuStatus(false)}>
            Solutions
          </NavLink> */}
          <NavLink to="/vendors" onClick={() => setMenuStatus(false)}>
            Vendors
          </NavLink>
          {/* <NavLink to="/services" onClick={() => setMenuStatus(false)}>
            Services
          </NavLink> */}
          <NavLink to="/events" onClick={() => setMenuStatus(false)}>
            Events
          </NavLink>
          <NavLink to="/partnerwithus" onClick={() => setMenuStatus(false)}>
            Partner with us
          </NavLink>
          <NavLink to="/blog" onClick={() => setMenuStatus(false)}>
            Blogs
          </NavLink>
          <NavLink to="/contactus" onClick={() => setMenuStatus(false)}>
            Contact
          </NavLink>  
        </div>
      </div>
    </section>
  );
};

export default SideBar;
